export default {
  icon: {
    marginRight: '8px'
  }
}
